import { render, staticRenderFns } from "./InventoryTypeDetail.vue?vue&type=template&id=6159f6c1&scoped=true"
import script from "./InventoryTypeDetail.vue?vue&type=script&lang=js"
export * from "./InventoryTypeDetail.vue?vue&type=script&lang=js"
import style0 from "./InventoryTypeDetail.vue?vue&type=style&index=0&id=6159f6c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6159f6c1",
  null
  
)

export default component.exports